export enum ObservationControllerMode {
    DEFAULT,
    REVIEW,
    POP_UP,
}
